<template>
    <Transition name="fade" @after-leave="onAfterLeave">
        <div v-if="visible" class="fixed left-0 top-0 z-10 flex h-dvh w-screen items-center justify-center bg-black/80">
            <div class="bg-gradient flex w-4/5 max-w-lg flex-col gap-10 rounded-xl p-12">
                <div class="grow whitespace-pre-line text-center text-white" :class="textClass">{{ props.text }}</div>
                <div class="flex items-center justify-center gap-3">
                    <button v-if="showCancel" class="cancel-btn rounded-md px-8 py-2" @click="close(false)">取消</button>
                    <button class="submit-btn" @click="close(true)">確定</button>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { onMounted, ref } from "vue";

const props = defineProps({
    text: {
        type: String,
    },
    textClass: {
        type: String,
    },
    showCancel: {
        type: Boolean,
    },
});
const emits = defineEmits(["close"]);
const visible = ref(false);

onMounted(() => {
    visible.value = true;
});

const currentClick = ref();
const close = (confirmed) => {
    visible.value = false;
    currentClick.value = confirmed;
};
const onAfterLeave = () => {
    emits("close", currentClick.value);
};
</script>
